import { FETCH_ALL_PARTNERS, FETCH_PARTNER } from "../types";
import apiService from "../../../services/apiService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchPartnersData = () => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_PARTNERS,
    message: `All partners data`,
    // payload: fetchService(`${baseUrl.backend}/api/partners`),
    payload: apiService({
      path: `${baseUrl.backend}/api/partners`,
      method: "GET",
      options: {},
    }),
  });

export const fetchPartnerData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_PARTNER,
    message: `Partner data`,
    // payload: fetchService(`${baseUrl.backend}/api/partners/${id}`),
    payload: apiService({
      path: `${baseUrl.backend}/api/partners/${id}`,
      method: "GET",
      options: {},
    }),
  });
